import {
  GET_WELCOME,
  GET_REMINDERS,
  GET_TRAINING,
  GET_VC,
  SIGN_OUT,
} from "../actions/types";

const INITIAL_STATE = {
  welcome: null,
  reminders: null,
  training: null,
  vc: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_WELCOME:
      return { ...state, welcome: action.payload };
    case GET_REMINDERS:
      return { ...state, reminders: action.payload };
    case GET_TRAINING:
      return { ...state, training: action.payload };
    case GET_VC:
      return { ...state, vc: action.payload };
    case SIGN_OUT:
      return { ...state, ...INITIAL_STATE };
    default:
      return state;
  }
};
